import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";

export function SessionRoom({ s, club, onChange }) {
  const [rooms, setRooms] = useState(null);
  useEffect(() => { api.get("/rooms").then((r) => setRooms(r.data)).catch(() => setRooms([])); }, []);
  const pick = async (room_id) => {
    try {
      await api.post(`/weekly-sessions/${s.id}/room`, { room_id: room_id || null });
      toast.success(room_id ? "Sala reservada" : "Sala libertada");
      onChange?.();
    } catch (err) { toast.error(formatApiError(err)); }
  };
  if (!rooms) return null;
  return (
    <select className="kw-input !py-1.5 md:!w-44 text-xs" value={s.room_id || ""} onChange={(e) => pick(e.target.value)}
      data-testid={`session-room-${club || s.id}`}>
      <option value="">— Sem sala —</option>
      {rooms.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
    </select>
  );
}
